import { getBrandingConfigFromWindow } from 'shared/helpers/brandingText';

const DEFAULT_BRAND_BASE = 'https://devpanelx.com';

// Branded docs/changelog pages are not published yet (short /hc and /docs
// paths 404). Flip this when the pages exist.
export const EXTERNAL_DOCS_LINKS_ENABLED = false;

const getBrandBase = () => {
  const { helpURL, brandURL } = getBrandingConfigFromWindow();
  return (helpURL || brandURL || DEFAULT_BRAND_BASE).replace(/\/$/, '');
};

const brandPath = path => `${getBrandBase()}${path}`;

const FEATURE_HELP_PATHS = {
  agent_bots: '/hc/agent-bots',
  agents: '/hc/agents',
  audit_logs: '/hc/audit-logs',
  campaigns: '/hc/campaigns',
  canned_responses: '/hc/canned',
  channel_email: '/hc/email',
  channel_facebook: '/hc/fb',
  custom_attributes: '/hc/custom-attributes',
  dashboard_apps: '/hc/dashboard-apps',
  help_center: '/hc/help-center',
  inboxes: '/hc/inboxes',
  integrations: '/hc/integrations',
  labels: '/hc/labels',
  macros: '/hc/macros',
  reports: '/hc/reports',
  sla: '/hc/sla',
  team_management: '/hc/teams',
  webhook: '/hc/webhooks',
  billing: '/pricing',
  saml: '/hc/saml',
  captain_billing: '/hc/captain_billing',
};

export const CAPTAIN_HELP_URLS = {
  get assistant() {
    return EXTERNAL_DOCS_LINKS_ENABLED
      ? brandPath('/hc/captain-assistant')
      : '';
  },
  get document() {
    return EXTERNAL_DOCS_LINKS_ENABLED ? brandPath('/hc/captain-document') : '';
  },
  get faq() {
    return EXTERNAL_DOCS_LINKS_ENABLED ? brandPath('/hc/captain-faq') : '';
  },
  get tools() {
    return EXTERNAL_DOCS_LINKS_ENABLED ? brandPath('/hc/captain-tools') : '';
  },
};

export const getUserGuideUrl = () =>
  EXTERNAL_DOCS_LINKS_ENABLED ? brandPath('/hc/user-guide/en') : '';

export const getChangelogUrl = () =>
  EXTERNAL_DOCS_LINKS_ENABLED ? `${getBrandBase()}/changelog/` : '';

export const getDocsUrl = (path = '/docs/product/') => {
  if (!EXTERNAL_DOCS_LINKS_ENABLED) return '';

  const { docsURL } = getBrandingConfigFromWindow();
  if (docsURL) {
    return `${docsURL.replace(/\/$/, '')}${path}`;
  }
  return brandPath(path);
};

export const getHelpUrlForFeature = featureName => {
  if (!EXTERNAL_DOCS_LINKS_ENABLED) return undefined;

  const serverUrls = window.chatwootConfig?.helpUrls || {};
  const serverUrl = serverUrls[featureName];
  if (serverUrl) return serverUrl;

  const helpPath = FEATURE_HELP_PATHS[featureName];
  return helpPath ? brandPath(helpPath) : undefined;
};

export const getBrandedLearnMoreUrl = url => {
  const slug = url.match(/\/blog\/([^/?#]+)/i)?.[1];
  if (slug) return `${getBrandBase()}/blog/${slug}`;
  return url;
};

export const hasCustomHelpBase = () => {
  const { helpURL, docsURL, brandURL } = getBrandingConfigFromWindow();
  return Boolean(helpURL || docsURL || brandURL);
};
